window.addEventListener('load', (event) => {

  // REGEX VALIDATION CHECK FOR PHONE. 0から始まり、残りの数字9桁または10桁の半角数字
  function phoneValidationCheck(phone) {
    return /^0\d{9,10}$/.test(phone)
  }

  // HANDLE WARNING TEXTS BASED ON THE PHONE ISSUE
  const phoneInput = document.getElementById("Phone");
  const phoneRuleText = document.getElementById("phoneRule");
  if (phoneInput) {
    phoneInput.addEventListener('blur', (event) => {
      if (phoneValidationCheck(event.target.value) == false && event.target.value != "") {
        console.log('phone number is missing')
        phoneRuleText.style.display = 'block'
      } else {
        phoneRuleText.style.display = 'none'
      }
    })
  }

  //CUSTOMER REGISTER VALIDATION NULL CHECK AND PHONE VALIDATE
  const registerCustomerButton = document.getElementById('register-submit');
  if (registerCustomerButton) {
    registerCustomerButton.addEventListener('click', (event) => {
      let nullFlag = false;
      const requireInputs = document.querySelectorAll("input.require");

      // HIDE REQUIRE ERROR * FIRST TIME
      const errorVisible = document.querySelectorAll(".require-error");
      for (const text of errorVisible) {
        text.style.display = "none";
      }
      // CHECK IF INPUT NULL
      for (const input of requireInputs) {
        if (!input.value) {
          // console.log("input value is null");
          nullFlag = true;
          const label = input.previousElementSibling;
          // Error対応 labelが存在し、label内にエラーメッセージがある場合にのみ表示
          if (label && label.querySelector(".require-error")) {
            label.querySelector(".require-error").style.display = "inline-block";
          }
          const errorText = input.nextElementSibling.querySelector(".require-error");
          if (errorText) {
            errorText.style.display = "inline-block";
          }
        }
      }
      if (phoneInput) {
        if (phoneValidationCheck(phoneInput.value) == false) {
          nullFlag = true;
        }
      }

      // GENDER VALIDATION CHECK
      const genderSelect = document.getElementById("Gender");
      if (genderSelect) {
        if (!genderSelect.value) {
          nullFlag = true;
          const genderErrorSpan = document.querySelector("label[for='Gender'] .require-error");
          if (genderErrorSpan) {
            genderErrorSpan.style.display = "inline-block";
          }
          document.querySelector("#gender-error").style.display = "inline-block";
        }
      }
      
      // CHECK IF PRAIVACY POLICY CHECKED
      const privacyPolicy = document.getElementById("privacy-policy");
      if (privacyPolicy.checked === false) {
        nullFlag = true;
        console.log("privacy false");
        document.getElementById("privacyError").style.display = "inline-block";
      }
      if (nullFlag) {
        event.preventDefault();
      }
    })
  }

});
